import { ImVideoCamera } from "react-icons/im";
import { RiHome3Fill, RiMovieFill } from "react-icons/ri";
import { HiMiniDocumentMagnifyingGlass } from "react-icons/hi2";
import { IoMdContact } from "react-icons/io";
import { PiFilmSlateBold } from "react-icons/pi";
import { HiStar } from "react-icons/hi2";

export const links = [
  {
    id: 1,
    icon: <RiHome3Fill />,
    name: "HOME",
    url: "#home",
  },
  {
    id: 2,
    icon: <HiMiniDocumentMagnifyingGlass />,
    name: "ABOUT",
    url: "#about",
  },
  {
    id: 3,
    icon: <ImVideoCamera />,
    name: "RECOMMEND",
    url: "#recommend",
  },
  {
    id: 4,
    icon: <PiFilmSlateBold />,
    name: "COMING SOON",
    url: "#comingsoon",
  },
  {
    id: 5,
    icon: <RiMovieFill />,
    name: "WATCH",
    url: "#watch",
  },
  {
    id: 6,
    icon: <HiStar />,
    name: "STARS",
    url: "#actors",
  },
  {
    id: 7,
    icon: <IoMdContact />,
    name: "CONTACT",
    url: "#contactUs",
  },
];

export const ThabinThalMyaHninSi = [
  {
    id: "1",
    title: "သဘင်သည်မြနှင်းဆီ အပိုင်း-1",
    directors: ["ကိုဆက်"],
    artists: ["မင်းဆက်သစ်, စည်သူအုတ်စိုး, ကောင်းထက်ပိုင်, စင်ဒီမြတ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MyaHninSiDesktop.jpg",
    url: "https://www.youtube.com/watch?v=_Mjke8ErESc&list=PLs9cgwdepJowhftMNYyMkwoKOu_AVeBvL&index=1",
  },
  {
    id: "2",
    title: "သဘင်သည်မြနှင်းဆီ အပိုင်း-2",
    directors: ["ကိုဆက်"],
    artists: ["မင်းဆက်သစ်, စည်သူအုတ်စိုး, ကောင်းထက်ပိုင်, စင်ဒီမြတ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MyaHninSiDesktop.jpg",
    url: "https://www.youtube.com/watch?v=JET1N3Xh_UQ&list=PLs9cgwdepJowhftMNYyMkwoKOu_AVeBvL&index=2",
  },
  {
    id: "3",
    title: "သဘင်သည်မြနှင်းဆီ အပိုင်း-3",
    directors: ["ကိုဆက်"],
    artists: ["မင်းဆက်သစ်, စည်သူအုတ်စိုး, ကောင်းထက်ပိုင်, စင်ဒီမြတ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MyaHninSiDesktop.jpg",
    url: "https://www.youtube.com/watch?v=0ftUpd0oD5A&list=PLs9cgwdepJowhftMNYyMkwoKOu_AVeBvL&index=3",
  },
  {
    id: "4",
    title: "သဘင်သည်မြနှင်းဆီ အပိုင်း-4",
    directors: ["ကိုဆက်"],
    artists: ["မင်းဆက်သစ်, စည်သူအုတ်စိုး, ကောင်းထက်ပိုင်, စင်ဒီမြတ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MyaHninSiDesktop.jpg",
    url: "https://www.youtube.com/watch?v=e0nBnqfw1FM&list=PLs9cgwdepJowhftMNYyMkwoKOu_AVeBvL&index=4",
  },
  {
    id: "5",
    title: "သဘင်သည်မြနှင်းဆီ အပိုင်း-5",
    directors: ["ကိုဆက်"],
    artists: ["မင်းဆက်သစ်, စည်သူအုတ်စိုး, ကောင်းထက်ပိုင်, စင်ဒီမြတ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MyaHninSiDesktop.jpg",
    url: "https://www.youtube.com/watch?v=_chF4bh3Qw4&list=PLs9cgwdepJowhftMNYyMkwoKOu_AVeBvL&index=5",
  },
  {
    id: "6",
    title: "သဘင်သည်မြနှင်းဆီ အပိုင်း-6",
    directors: ["ကိုဆက်"],
    artists: ["မင်းဆက်သစ်, စည်သူအုတ်စိုး, ကောင်းထက်ပိုင်, စင်ဒီမြတ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MyaHninSiDesktop.jpg",
    url: "https://www.youtube.com/watch?v=O9W1sQ7Ubrk&list=PLs9cgwdepJowhftMNYyMkwoKOu_AVeBvL&index=6",
  },
  {
    id: "7",
    title: "သဘင်သည်မြနှင်းဆီ အပိုင်း-7",
    directors: ["ကိုဆက်"],
    artists: ["မင်းဆက်သစ်, စည်သူအုတ်စိုး, ကောင်းထက်ပိုင်, စင်ဒီမြတ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MyaHninSiDesktop.jpg",
    url: "https://www.youtube.com/watch?v=f-wKUw-caAc",
  },
  {
    id: "8",
    title: "သဘင်သည်မြနှင်းဆီ အပိုင်း-8",
    directors: ["ကိုဆက်"],
    artists: ["မင်းဆက်သစ်, စည်သူအုတ်စိုး, ကောင်းထက်ပိုင်, စင်ဒီမြတ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MyaHninSiDesktop.jpg",
    url: "https://www.youtube.com/watch?v=cKXPZYm-axE&list=PLs9cgwdepJowhftMNYyMkwoKOu_AVeBvL&index=7",
  },
  {
    id: "9",
    title: "သဘင်သည်မြနှင်းဆီ အပိုင်း-9",
    directors: ["ကိုဆက်"],
    artists: ["မင်းဆက်သစ်, စည်သူအုတ်စိုး, ကောင်းထက်ပိုင်, စင်ဒီမြတ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MyaHninSiDesktop.jpg",
    url: "https://www.youtube.com/watch?v=j5UsHhDvhwo&list=PLs9cgwdepJowhftMNYyMkwoKOu_AVeBvL&index=8",
  },
];

export const BehindTheWallLinks = [
  {
    id: "1",
    title: "နံရံ၏နောက်ကွယ်",
    directors: ["ဟိန်းဇော်"],
    artists: ["ထိုက်တန်", "စစ်နိုင်", "ဘုန်းသျှံ", "ရဲမျိုးမြတ်လင်းအောင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/BTW_001.jpg",
    url: "https://www.youtube.com/watch?v=w3Ht71_ssNA",
  },
  {
    id: "2",
    title: "နံရံ၏နောက်ကွယ်",
    directors: ["ဟိန်းဇော်"],
    artists: ["ထိုက်တန်", "စစ်နိုင်", "ဘုန်းသျှံ", "ရဲမျိုးမြတ်လင်းအောင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/BTW_002.jpg",
    url: "https://www.youtube.com/watch?v=YiWs5i7zhRc&t=62s",
  },
  {
    id: "3",
    title: "နံရံ၏နောက်ကွယ်",
    directors: ["ဟိန်းဇော်"],
    artists: ["ထိုက်တန်", "စစ်နိုင်", "ဘုန်းသျှံ", "ရဲမျိုးမြတ်လင်းအောင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/BTW_003.jpg",
    url: "https://www.youtube.com/watch?v=ExkAY78YvEc",
  },
  {
    id: "4",
    title: "နံရံ၏နောက်ကွယ်",
    directors: ["ဟိန်းဇော်"],
    artists: ["ထိုက်တန်", "စစ်နိုင်", "ဘုန်းသျှံ", "ရဲမျိုးမြတ်လင်းအောင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/BTW_004.jpg",
    url: "https://www.youtube.com/watch?v=GV55hM7Zqng",
  },
  {
    id: "5",
    title: "နံရံ၏နောက်ကွယ်",
    directors: ["ဟိန်းဇော်"],
    artists: ["ထိုက်တန်", "စစ်နိုင်", "ဘုန်းသျှံ", "ရဲမျိုးမြတ်လင်းအောင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/BTW_005.jpg",
    url: "https://www.youtube.com/watch?v=WsTITUatsVM",
  },
  {
    id: "6",
    title: "နံရံ၏နောက်ကွယ်",
    directors: ["ဟိန်းဇော်"],
    artists: ["ထိုက်တန်", "စစ်နိုင်", "ဘုန်းသျှံ", "ရဲမျိုးမြတ်လင်းအောင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/BTW_006.jpg",
    url: "https://www.youtube.com/watch?v=LvKI_aDM37w",
  },
  {
    id: "7",
    title: "နံရံ၏နောက်ကွယ်",
    directors: ["ဟိန်းဇော်"],
    artists: ["ထိုက်တန်", "စစ်နိုင်", "ဘုန်းသျှံ", "ရဲမျိုးမြတ်လင်းအောင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/BTW_007.jpg",
    url: "https://www.youtube.com/watch?v=009Ln9mr8ms",
  },
  {
    id: "8",
    title: "နံရံ၏နောက်ကွယ်",
    directors: ["ဟိန်းဇော်"],
    artists: ["ထိုက်တန်", "စစ်နိုင်", "ဘုန်းသျှံ", "ရဲမျိုးမြတ်လင်းအောင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/BTW_008.jpg",
    url: "https://www.youtube.com/watch?v=ayH9PpGWBbg",
  },
];

export const AungMyatTharLinks1 = [
  {
    id: "1",
    title: "အောင်မြတ်သာနှင့်တွေ့ဆုံခြင်း",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ဟန်ဆက်လူ", "နန်းခန်းဝါ"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_001.jpg",
    url: "https://www.youtube.com/watch?v=uKnkXsJra-0",
  },
  {
    id: "2",
    title: "အောင်မြတ်သာနှင့်ဖုတ်ဝင်သူ",
    directors: ["သီဟမင်းညီ"],
    artists: [
      "စစ်နိုင်",
      "လင်းအောင်",
      "ဇော်ကြီး",
      "ဖိုးကျော်",
      "ငြိမ်းငြိမ်းထက်",
    ],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_002.jpg",
    url: "https://www.youtube.com/watch?v=W3YROv81XrM",
  },
  {
    id: "3",
    title: "အောင်မြတ်သာနှင့် မြင်းမဟီရွာ(၁)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ကျော်ဇောဟိန်း"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_003.jpg",
    url: "https://www.youtube.com/watch?v=YBtXX2KvBlI",
  },
  {
    id: "4",
    title: "အောင်မြတ်သာနှင့် မြင်းမဟီရွာ(၂)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "မင်းဇော်", "ကျင်ဝမ်း", "ချမ်းမြေ့"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_004.jpg",
    url: "https://www.youtube.com/watch?v=TjkDCxAiv7M",
  },
  {
    id: "5",
    title: "အောင်မြတ်သာနှင့် မေတ္တာလွန်ဆွဲပွဲ(၁)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "စံပယ်မိုး", "ဝါဝါအောင်", "ဇွဲလပြည့်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_005.jpg",
    url: "https://www.youtube.com/watch?v=UmD2ux5ptYg",
  },
  {
    id: "6",
    title: "အောင်မြတ်သာနှင့် မေတ္တာလွန်ဆွဲပွဲ(၂)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "စံပယ်မိုး", "ဝါဝါအောင်", "ဇွဲလပြည့်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_006.jpg",
    url: "https://www.youtube.com/watch?v=C7hsLGmG754",
  },
  {
    id: "7",
    title: "အောင်မြတ်သာနှင့် ဆယ့်နှစ်ကြိုးရွာ",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ကောင်းဟိန်း", "ပြည်ဖြိုးအောင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_007.jpg",
    url: "https://www.youtube.com/watch?v=6Oorh0SNiE8",
  },
  {
    id: "8",
    title: "အောင်မြတ်သာနှင့် အပင်းတိုက်သူ",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ရဲရင့်ဆူး", "ခိုင်သဇင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_008.jpg",
    url: "https://www.youtube.com/watch?v=v89M4mZF35g",
  },
  {
    id: "9",
    title: "အောင်မြတ်သာနှင့် ဝိဥာဥ်လွှင့်သူငစနေ",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "ညီညီမင်းထက်", "လင်းအောင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_009.jpg",
    url: "https://www.youtube.com/watch?v=GVViApkclI0",
  },
  {
    id: "10",
    title: "အောင်မြတ်သာနှင့် ဆေး‌ကဝေ",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ဦးစံပေါ", "မျိုးကြည်", "ဗညား"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_010.jpg",
    url: "https://www.youtube.com/watch?v=yT-ZJX-7h4M",
  },
  {
    id: "11",
    title: "အောင်မြတ်သာနှင့် အောက်လမ်းဆရာဘမှန်",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "နေရဲလင်း", "လင်းအောင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_011.jpg",
    url: "https://www.youtube.com/watch?v=YxJ-Gf5_RPM",
  },
  {
    id: "12",
    title: "အောင်မြတ်သာနှင့် သွေးမျက်ရည်(အပိုင်း၁)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ရှင်မိုးဦး", "မင်းသစ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_012.jpg",
    url: "https://www.youtube.com/watch?v=U5utEajiOM4",
  },
  {
    id: "13",
    title: "အောင်မြတ်သာနှင့် သွေးမျက်ရည်(အပိုင်း၂)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ရှင်မိုးဦး", "ကိုဘဂျမ်း"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_013.jpg",
    url: "https://www.youtube.com/watch?v=Cm-dbVZtE2c",
  },
  {
    id: "14",
    title: "အောင်မြတ်သာနှင့် လိပ်ပြာနှုတ်ပွဲ",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ဟိန်းစစ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_014.jpg",
    url: "https://www.youtube.com/watch?v=NgrAoJmOCzM",
  },
  {
    id: "15",
    title: "အောင်မြတ်သာနှင့် အရူးကျင့်စဥ်",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "မျိုးကို"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_015.jpg",
    url: "https://www.youtube.com/watch?v=QwjlgLHpbOQ",
  },
  {
    id: "16",
    title: "အောင်မြတ်သာနှင့် ဘုရားစောင့်မြွေ",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "မင်းသူ", "လင်းအောင်", "မျိုးကို"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_016.jpg",
    url: "https://www.youtube.com/watch?v=gjxDmzRrtq4",
  },
  {
    id: "17",
    title: "အောင်မြတ်သာနှင့် ဒုဠဝတီရှင်းတမ်း",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ဆုလှိုင်နှင်း"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_017.jpg",
    url: "https://www.youtube.com/watch?v=8h9CjKjeSFA",
  },
  {
    id: "18",
    title: "အောင်မြတ်သာနှင့် ဝိညာဉ်စွဲကပ်မှန်တစ်ချပ်(အပိုင်း၁)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "မျိုးကို", "နန်းဆုဦး", "ယွန်းရွှေရည်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_018.jpg",
    url: "https://www.youtube.com/watch?v=6MPPV9jyr8Q",
  },
  {
    id: "19",
    title: "အောင်မြတ်သာနှင့် ဝိညာဉ်စွဲကပ်မှန်တစ်ချပ်(အပိုင်း၂)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "မျိုးကို", "နန်းဆုဦး", "ယွန်းရွှေရည်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_019.jpg",
    url: "https://www.youtube.com/watch?v=tkm8DjxU__U",
  },
  {
    id: "20",
    title: "အောင်မြတ်သာနှင့် ရေသရဲ",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "ထူးခြား", "လင်းအောင်", "မျိုးကို"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_020.jpg",
    url: "https://www.youtube.com/watch?v=wF4Nl6MN81A",
  },
  {
    id: "21",
    title: "အောင်မြတ်သာနှင့် တတိယမျက်လုံးကျင့်စဥ်",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "ခရစ္စတီးနား", "လင်းအောင်", "မျိုးကို"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_021.jpg",
    url: "https://www.youtube.com/watch?v=uJuQreY2THU",
  },
  {
    id: "22",
    title: "အောင်မြတ်သာနှင့် အိမ့်တစ်လိမ့်စုန်း",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "မျိုးကို", "အိမြတ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_022.jpg",
    url: "https://www.youtube.com/watch?v=N0RG9hE5Nwc",
  },
  {
    id: "23",
    title: "အောင်မြတ်သာနှင့် ကတ္တီပါစံအိမ်(အပိုင်း၁)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "မျိုးကို", "ရွှေပိုးအိမ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_023.jpg",
    url: "https://www.youtube.com/watch?v=-D_TgmGj9m8",
  },
  {
    id: "24",
    title: "အောင်မြတ်သာနှင့် ကတ္တီပါစံအိမ်(အပိုင်း၂)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "မျိုးကို", "ရွှေပိုးအိမ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_024.jpg",
    url: "https://www.youtube.com/watch?v=EUItIkNHcuk",
  },
  {
    id: "25",
    title: "အောင်မြတ်သာနှင့် ကြောင်နက်မှော်(အပိုင်း၁)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "မျိုးကို", "စိုင်းသီဟ"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_025.jpg",
    url: "https://www.youtube.com/watch?v=LMMaQYgXWKA",
  },
  {
    id: "26",
    title: "အောင်မြတ်သာနှင့် ကြောင်နက်မှော်(အပိုင်း၂)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "မျိုးကို", "စိုင်းသီဟ"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_026.jpg",
    url: "https://www.youtube.com/watch?v=X_XXk83zwds",
  },
  {
    id: "27",
    title: "အောင်မြတ်သာနှင့် ကြောင်မျက်ရှင်(အပိုင်း၁)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "မျိုးကို", "ဖြူစင်ဝင့်ရှိန်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_027.jpg",
    url: "https://www.youtube.com/watch?v=zviiJ1VLLRY",
  },
  {
    id: "28",
    title: "အောင်မြတ်သာနှင့် ကြောင်မျက်ရှင်(အပိုင်း၂)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "မျိုးကို", "ဖြူစင်ဝင့်ရှိန်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_028.jpg",
    url: "https://www.youtube.com/watch?v=y7x2CBfNRRc",
  },
  {
    id: "29",
    title: "အောင်မြတ်သာနှင့် နတ်ရှင်စော(အပိုင်း၁)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "မျိုးကို", "ကျော်ဇောဟိန်း"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_029.jpg",
    url: "https://www.youtube.com/watch?v=QNJhCw5gO38",
  },
  {
    id: "30",
    title: "အောင်မြတ်သာနှင့် နတ်ရှင်စော(အပိုင်း၂)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "မျိုးကို", "ကျော်ဇောဟိန်း"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_030.jpg",
    url: "https://www.youtube.com/watch?v=dfqEndusbvY",
  },
  {
    id: "31",
    title: "အောင်မြတ်သာနှင့် နှလုံးခြေကဝေ",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "မိုးပြည့်ပြည့်မောင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_031.jpg",
    url: "https://www.youtube.com/watch?v=7GKcBA9K360",
  },
  {
    id: "32",
    title: "အောင်မြတ်သာနှင့် ဝေမာနိကပြိတ္တာ(ပထမပိုင်း)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "ယွန်းရွှေရည်", "လင်းအောင်", "မျိုးကို"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_032.jpg",
    url: "https://www.youtube.com/watch?v=Ll5vaYb4pBA",
  },
  {
    id: "33",
    title: "အောင်မြတ်သာနှင့် ဝေမာနိကပြိတ္တာ(ဇာတ်သိမ်း)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "ယွန်းရွှေရည်", "လင်းအောင်", "မျိုးကို"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_033.jpg",
    url: "https://www.youtube.com/watch?v=J6JcWToH0bE",
  },
  {
    id: "34",
    title: "အောင်မြတ်သာနှင့် ပုဏ္ဏကတိုက်တဲ့အိမ်ကြီး(ပထမပိုင်း)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "ယွန်းရွှေရည်", "ထူးသာ", "ပွင့်နဒီမောင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_034.jpg",
    url: "https://www.youtube.com/watch?v=1UAM4Mndjhc",
  },
  {
    id: "35",
    title: "အောင်မြတ်သာနှင့် ပုဏ္ဏကတိုက်တဲ့အိမ်ကြီး(ဇာတ်သိမ်း)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ထူးသာ", "ပွင့်နဒီမောင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_035.jpg",
    url: "https://www.youtube.com/watch?v=2K8EaokE3oI",
  },
  {
    id: "36",
    title: "အောင်မြတ်သာနှင့် ဇော်ဂျီဖိုဝင်",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "ရဲမိုး", "ရဲရင့်ထူး"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_036.jpg",
    url: "https://www.youtube.com/watch?v=wFy1xlgtTYc",
  },
  {
    id: "37",
    title: "အောင်မြတ်သာနှင့် ဆံဖြူကဝေ",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "ဦးညီညီမင်း", "ဒေါ်ခင်အုန်းမြင့်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_037.jpg",
    url: "https://www.youtube.com/watch?v=ZCGvOJUT8kA",
  },
  {
    id: "38",
    title: "အောင်မြတ်သာနှင့် ဘုရားပျက်ကုန်း",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ဦးဇော်မှိုင်း", "အုန်းသီး"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_038.jpg",
    url: "https://www.youtube.com/watch?v=TpT5bzSApDY",
  },
  {
    id: "39",
    title: "အောင်မြတ်သာနှင့် အင်းပိုင်ကြီးဘထွန်း",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ဘုန်းလျှံ", "ဝေဠု", "မြတ်ဆုချယ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_039.jpg",
    url: "https://www.youtube.com/watch?v=wad2iSCqs5o",
  },
  {
    id: "40",
    title: "အောင်မြတ်သာနှင့် ထမီခြုံလင်းတမယ် ",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ခင်စိုးပိုင်", "မျိုးကို"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_040.jpg",
    url: "https://www.youtube.com/watch?v=FhJu8eL326E",
  },
  {
    id: "41",
    title: "အောင်မြတ်သာနှင့် မီးတောက်ဘပြုံး",
    directors: ["သီဟမင်းညီ"],
    artists: [
      "စစ်နိုင်",
      "လင်းအောင်",
      "ကျော်ကျော်",
      "မျိုးကို",
      "မိုးစက်",
      "ကိုဆွိ",
    ],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_041.jpg",
    url: "https://www.youtube.com/watch?v=3BgpwF6nuUk",
  },
  {
    id: "42",
    title: "အောင်မြတ်သာနှင့် ရေကန်စောင့်မောင်နှမ",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "ဒေါင်းဝေ", "ခိုင်သဇင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_042.jpg",
    url: "https://www.youtube.com/watch?v=upSCgs9oY40",
  },
  {
    id: "43",
    title: "အောင်မြတ်သာနှင့် ဘုံဘဝမှာဖြင့်(ပထမပိုင်း)",
    directors: ["သီဟမင်းညီ"],
    artists: [
      "စစ်နိုင်",
      "လင်းအောင်",
      "မိုခမ်း",
      "ရှိုင်းဝဏ္ဏအောင်",
      "မေသရဖီကျော်",
    ],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_043.jpg",
    url: "https://www.youtube.com/watch?v=DfYJ3Ada50M",
  },
  {
    id: "44",
    title: "အောင်မြတ်သာနှင့် ဘုံဘဝမှာဖြင့်(ဒုတိယပိုင်း)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ဦးညီညီမင်း", "အားကိုးရာ", "ငြိမ်းဆုဝေ"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_044.jpg",
    url: "https://www.youtube.com/watch?v=BpQ0x0WLfCY",
  },
  {
    id: "45",
    title: "အောင်မြတ်သာနှင့် ဘုံဘဝမှာဖြင့်(တတိယပိုင်း)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ဦးညီညီမင်း", "အားကိုးရာ", "ငြိမ်းဆုဝေ"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_045.jpg",
    url: "https://www.youtube.com/watch?v=FuxU_l0Of9Y",
  },
  {
    id: "46",
    title: "အောင်မြတ်သာနှင့် ဘုံဘဝမှာဖြင့်(စတုတ္ထပိုင်း)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ဦးညီညီမင်း", "အားကိုးရာ", "ငြိမ်းဆုဝေ"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_046.jpg",
    url: "https://www.youtube.com/watch?v=p6TA7t35Xn0",
  },
  {
    id: "47",
    title: "အောင်မြတ်သာနှင့် ဘုံဘဝမှာဖြင့်(5)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ဦးညီညီမင်း", "အားကိုးရာ", "ငြိမ်းဆုဝေ"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_047.jpg",
    url: "https://www.youtube.com/watch?v=V0JbuEOZcTY",
  },
  {
    id: "48",
    title: "အောင်မြတ်သာနှင့် ဘုံဘဝမှာဖြင့်(6)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ဦးညီညီမင်း", "အားကိုးရာ", "ငြိမ်းဆုဝေ"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_048.jpg",
    url: "https://www.youtube.com/watch?v=hCo-fI67EDM",
  },
  {
    id: "49",
    title: "အောင်မြတ်သာနှင့် ဝိညာဉ်လေးကောင်",
    directors: ["သီဟမင်းညီ"],
    artists: [
      "စစ်နိုင်",
      "လင်းအောင်",
      "မျိုးကို",
      "ကျော်ဝင်းထွဋ်",
      "ပိုးဝါလေး",
    ],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_049.jpg",
    url: "https://www.youtube.com/watch?v=3kzCEHTKI5s",
  },
  {
    id: "50",
    title: "အောင်မြတ်သာနှင့် သွေးစုပ်ငှက်ပျောပင်",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ညီကျော်", "ပိုင်သူဖြိုး", "ကျော်သစ်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_050.jpg",
    url: "https://www.youtube.com/watch?v=wE90ZG4OGD4",
  },
  {
    id: "51",
    title: "အောင်မြတ်သာနှင့် သစ်စုန်းတိုက်",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "မျိုးကို", "မိုးစက်ရှိုင်း"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_051.jpg",
    url: "https://www.youtube.com/watch?v=JxZ6Uvj4g9A",
  },
  {
    id: "52",
    title: "အောင်မြတ်သာနှင့် မဟာဒီပတွေ့ဆုံခြင်း",
    directors: ["သီဟမင်းညီ"],
    artists: [
      "စစ်နိုင်",
      "လင်းအောင်",
      "နောင်ထိပ်တင်",
      "အောင်သူဟိန်း",
      "နိုင်လူ",
    ],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_052.jpg",
    url: "https://www.youtube.com/watch?v=NAcupGt3__I",
  },
  {
    id: "53",
    title: "အောင်မြတ်သာနှင့် ပါရမီဖြည့်လမ်း (ပထမပိုင်း)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "ခိုင်ထူးသာ", "ယွန်းသဒ္ဒါအောင်", "ဒေါ်ခင်ခင်ကြီး"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_053.jpg",
    url: "https://www.youtube.com/watch?v=YAj2mD4vHiY",
  },
  {
    id: "54",
    title: "အောင်မြတ်သာနှင့် ပါရမီဖြည့်လမ်း (ဒုတိယပိုင်း)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "ခိုင်ထူးသာ", "ယွန်းသဒ္ဒါအောင်", "ဒေါ်ခင်ခင်ကြီး"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_053.jpg",
    url: "https://www.youtube.com/watch?v=Tz7vpIcKs44",
  },
  {
    id: "55",
    title: "အောင်မြတ်သာနှင့် ပါရမီဖြည့်လမ်း (ဇာတ်သိမ်းပိုင်း)",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "ခိုင်ထူးသာ", "ယွန်းသဒ္ဒါအောင်", "ဒေါ်ခင်ခင်ကြီး"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_054.jpg",
    url: "https://www.youtube.com/watch?v=CKdibsLOT40",
  },
  {
    id: "56",
    title: "အောင်မြတ်သာနှင့် အောက်လမ်းဆရာယက္ခ",
    directors: ["သီဟမင်းညီ"],
    artists: [
      "စစ်နိုင်",
      "လင်းအောင်",
      "မျိုးကို",
      "ဇင်မျိုး",
      "အောင်ရှိန်",
      "ရွှင်ပျော်",
    ],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_055.jpg",
    url: "https://www.youtube.com/watch?v=rb5hAXvCYDg",
  },
];

export const MovieLinks = [
  {
    id: "1",
    title: "လနတ်သမီးရေးတဲ့ဖူးစာ",
    directors: ["မောင်နီလွင်(သပြု)", ""],
    artists: ["တြိကို", "မျိုးစန္ဒီကျော်", "", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/OMM_001.jpg",
    url: "https://www.youtube.com/watch?v=heN62CbuVsA",
  },
  {
    id: "2",
    title: "ဒုတိယအသက်",
    directors: ["ကျော်ဇော်လင်း", ""],
    artists: ["ကျော်ဟိန်း", "ဖြိုးငွေစိုး", "ခိုင်သင်းကြည်", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/OMM_002.jpg",
    url: "https://www.youtube.com/watch?v=8VAUZOEkigY",
  },
  {
    id: "3",
    title: "ချစ်အမျှ",
    directors: ["မောင်တင်မောင်", ""],
    artists: ["မောင်တင်မောင်", "မေရှင်", "", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/OMM_003.jpg",
    url: "https://www.youtube.com/watch?v=qp_PuRynTmI",
  },
  {
    id: "4",
    title: "ချစ်သူရဲ့ပခုံးတစ်ဖက်",
    directors: ["ကိုဇော်(အာရုဏ်ဦး)", ""],
    artists: ["လွင်မိုး", "ပြေတီဦး", "ချစ်စနိုးဦး", "နဝရတ်", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/OMM_004.jpg",
    url: "https://www.youtube.com/watch?v=F6Al2TF5GWY",
  },
  {
    id: "5",
    title: "အခမ်းနားဆုံး",
    directors: ["အကယ်ဒမီ ‌မောင်နန္ဒ", ""],
    artists: ["တြိကို", "မေသန်းနု", "ကြည်လဲ့လဲ့ဦး", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/OMM_005.jpg",
    url: "https://www.youtube.com/watch?v=VSMCqjZgsGs",
  },
  {
    id: "6",
    title: "လင်‌‌‌‌ယောကျ်ားနှင့် မယားမိန်းမ",
    directors: ["ညီညီထွန်းလွင်", ""],
    artists: ["‌ကျော်ရဲ‌‌အောင်", "မေသန်းနု", "", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/OMM_006.jpg",
    url: "https://www.youtube.com/watch?v=QKY-zuC60Nw",
  },
  {
    id: "7",
    title: "သောကြာကြယ်ကတဲ့ရထား",
    directors: ["ညိုမင်းလွင်", ""],
    artists: ["ကောင်းပြည့်", "သင်ဇာဝင့်ကျော်", "ဝမ်းဝမ်း", "ဇင်ဘို", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/OMM_007.jpg",
    url: "https://www.youtube.com/watch?v=kNQKEfhOYJQ",
  },
  {
    id: "8",
    title: "ပျော်ပါရစေ",
    directors: ["ကိုဇော် (အာရုဏ်ဦး)", ""],
    artists: ["လွင်မိုး", "ဘုန်းသျှံ", "နဝရတ်", "မြတ်‌‌ကေသီအောင်", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/OMM_008.jpg",
    url: "https://www.youtube.com/watch?v=cBQZeoXnC4c",
  },
  {
    id: "9",
    title: "ယုံကြည်ခြင်းနှင်းဆီ",
    directors: ["ကိုဇော် (အာရုဏ်ဦး)", ""],
    artists: ["ပြေတီဦး ", "ဝတ်မှုံရွှေရည်", "ချောရတနာ", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/OMM_009.jpg",
    url: "https://www.youtube.com/watch?v=1BZ9qSHXbWM",
  },
];

export const FilmLinks = [
  {
    id: "1",
    title: "နိုနိုမေဂျူဂျူ",
    directors: ["နောင်ထွန်းလွင်", "ညီညီထွန်းလွင်"],
    artists: ["လွင်မိုး", "စိုးမြတ်သူဇာ", "မေသဥ္ဇာဦး", "ထက်ထက်မိုးဦး", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_001-1.jpg",
    url: "https://www.youtube.com/watch?v=5LOe04dmEcg",
  },
  {
    id: "2",
    title: "သင်္ကြန်ဝေးဝေး",
    directors: ["ညွန့်မြန်မာညီညီအောင်", ""],
    artists: ["လွင်မိုး", "ခန့်စည်သူ", "အိန္ဒြာကျော်ဇင်", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_002.jpg",
    url: "https://www.youtube.com/watch?v=fRWT2dm_fEc",
  },
  {
    id: "3",
    title: "ရွှေစွန်ညို",
    directors: ["အကယ်ဒမီ မောင်နန္ဒ", ""],
    artists: ["ရန်အောင်", "ကျော်ရဲအောင်", "အိန္ဒြာကျော်ဇင်", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_003.jpg",
    url: "https://www.youtube.com/watch?v=y16TEImw9aE",
  },
  {
    id: "4",
    title: "သံချောင်း",
    directors: ["ဝင်းထွန်းထွန်း", ""],
    artists: ["ထွန်းထွန်း", "နန္ဒ", "ဇင်ဝိုင်း", "အေးမြတ်သူ", "သဇင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_004.jpg",
    url: "https://www.youtube.com/watch?v=j7BbsKt7Czs",
  },
  {
    id: "5",
    title: "ပန်းသုံးပွင့်၏ ချစ်အိပ်မက်",
    directors: ["ကိုဇော်(အရုဏ်ဦး)", ""],
    artists: ["ပြေတီဦး", "စိုးမြတ်သူဇာ", "ထွန်းအိန္ဒြာဗို", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_005.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "7",
    title: "ပိုပြီးချစ်မယ့် မနက်ဖြန်",
    directors: ["ကိုဇော်(အရုဏ်ဦး)", ""],
    artists: ["ကျော်ရဲအောင်", "ရဲအောင်", "စိုးမြတ်သူဇာ", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_007.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "8",
    title: "သူငယ်ချင်းယောက္ခမ",
    directors: ["ကိုဇော်(အရုဏ်ဦး)", ""],
    artists: ["လွင်မိုး", "ကျော်ရဲအောင်", "စိုးမြတ်သူဇာ", "မိုးဟေကို", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_008.jpg",
    url: "https://www.youtube.com/watch?v=eTB3JyEA-kc&t=7s",
  },
  {
    id: "9",
    title: "သူငယ်ချင်းယောက္ခမ (၂)",
    directors: ["ကိုဇော်(အရုဏ်ဦး)", ""],
    artists: ["လွင်မိုး", "ကျော်ရဲအောင်", "စိုးမြတ်သူဇာ", "မိုးဟေကို", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_009.jpg",
    url: "https://www.youtube.com/watch?v=eTB3JyEA-kc&t=7s",
  },
  {
    id: "10",
    title: "နတ်ဖက်တဲ့စုံတွဲများ",
    directors: ["ကိုဇော်(အရုဏ်ဦး)", ""],
    artists: [
      "ရဲအောင်",
      "ပြေတီဦး",
      "နန္ဒ ",
      "စိုးမြတ်သူဇာ",
      "အိန္ဒြာကျော်ဇင်",
      "သက်မွန်မြင့်",
    ],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_010-1.jpg",
    url: "https://www.youtube.com/watch?v=wundDbaQzv4",
  },
  {
    id: "11",
    title: "နဂါး၊ ဂဠုန်၊ ကုမ္ဘာန်၊ ယက္ခ",
    directors: ["ညိုမင်းလွင်", ""],
    artists: [
      "သီဟတင်စိုး",
      "မင်းမော်ကွန်း",
      "နေထက်လင်း ",
      "ခိုင်သင်းကြည်",
      "",
      "",
    ],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_011-1.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "12",
    title: "လက်ပံ",
    directors: ["ဝိုင်း (Own Creator)", ""],
    artists: ["ပြေတီဦး", "စိုးမြတ်သူဇာ", "ဖွေးဖွေး", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_012.jpg",
    url: "https://www.youtube.com/watch?v=cMXE3D4b9oc",
  },
  {
    id: "13",
    title: "နင်စေရင်",
    directors: ["ဝိုင်း (Own Creator)", ""],
    artists: ["ပြေတီဦး", "မင်းဦး", "ဝတ်မှုံရွှေရည်", "", ""],
    summary: "https://www.youtube.com/watch?v=RWms-BdjV0w",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_013.png",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "14",
    title: "ကိုတင့်တို့ စူပါရပ်ကွက်",
    directors: ["ကျော်ဇောလင်း(အတွေးပုံရိပ်)", ""],
    artists: [
      "ပြေတီဦး",
      "နေတိုး",
      "မြင့်မြတ်",
      "အိန္ဒြာကျော်ဇင်",
      "သက်မွန်မြင့်",
      "ဝတ်မှုံရွှေရည်",
    ],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_014.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "15",
    title: "တိုက်ဆိုင်မှုရှိလျှင်",
    directors: ["မောင်မျိုးမင်း(ရင်တွင်းဖြစ်)", ""],
    artists: ["ပြေတီဦး", "မိုးဟေကို", "လိုင်လာခမ်း", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_015.jpg",
    url: "https://www.youtube.com/watch?v=3HyYqCoDW60",
  },
  {
    id: "16",
    title: "ရာဇဝင်ရိုင်းသူများ",
    directors: ["မောင်မျိုးမင်း(ရင်တွင်းဖြစ်)", ""],
    artists: ["ပြေတီဦး", "မြင့်မြတ်", "လိုင်လာခမ်း", "ပက်ထရစ်ရှာ", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_016.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "17",
    title: "စားတယ်",
    directors: ["ကျော်ဇောလင်း(အတွေးပုံရိပ်)", ""],
    artists: ["အရိုင်း", "ငှက်ပျောကြော်", "မိုးပြည့်ပြည့်မောင်", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/FIlm_017.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "18",
    title: "အနမ်းဝိုင်",
    directors: ["အောင်မြတ်", ""],
    artists: ["အောင်ရဲလင်း", "ဝတ်မှုံရွှေရည်", "", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_018.jpg",
    url: "https://www.youtube.com/watch?v=QvUkiKwP8ks",
  },
  {
    id: "19",
    title: "ရှယ်ချွေးမ",
    directors: ["ကိုဇော်(အရုဏ်ဦး)", ""],
    artists: [
      "ရန်အောင်",
      "အောင်ရဲလင်း",
      "စိုးမြတ်သူဇာ",
      "ထက်ထက်မိုးဦး",
      "ခင်ဝင့်ဝါ",
    ],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_019-1.jpg",
    url: "https://www.youtube.com/watch?v=OGlL45h16Yg",
  },
  {
    id: "20",
    title: "ကျွန်မအချစ်ဆုံးယောက်ျားသုံးယောက်",
    directors: ["မောင်မျိုးမင်း(ရင်တွင်းဖြစ်)", ""],
    artists: ["ရန်အောင်", "ရဲအောင်", "ပြေတီဦး", "စိုးမြတ်သူဇာ", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_020.jpg",
    url: "https://www.youtube.com/watch?v=dBreWw25BII",
  },
  {
    id: "21",
    title: "သမ္မတကြီးထံပေးစာ",
    directors: ["ဝိုင်း(Own Creator)", ""],
    artists: ["အလင်းရောင်", "ချမ်းမင်းရဲထွဋ်", "ဖွေးဖွေး", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_021.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "22",
    title: "ပုရိသ",
    directors: ["ကိုဇော်(အရုဏ်ဦး)", ""],
    artists: ["ကျော်ရဲအောင်", "ရဲအောင်", "ခိုင်သင်းကြည်", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_022.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "23",
    title: "ဣတ္တိယ",
    directors: ["ကိုဇော်(အရုဏ်ဦး)", ""],
    artists: ["အလင်းရောင်", "စိုးမြတ်သူဇာ", "ခိုင်သင်းကြည်", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_023.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "24",
    title: "၃/က",
    directors: ["အောင်ချမ်းလူ", ""],
    artists: ["ချမ်းမင်းရဲထွဋ်", "စိုးမြတ်သူဇာ", "နန်းဆုဦး", "", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_024.jpg",
    url: "https://www.youtube.com/watch?v=aQGuasCQJQQ",
  },
  {
    id: "25",
    title: "ဥပါဒန်",
    directors: ["ဗန်းကြီး", ""],
    artists: ["ခိုင်ထူးသာ", "ဇာတိ", "နန်းဆုဦး", "မေသဉ္ဇာဦး", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Film_025.jpg",
    url: "https://www.youtube.com/watch?v=3hanQYPkgeo",
  },
];

export const CoProducedData = [
  {
    id: "1",
    title: "ဥပါဒန်",
    directors: ["ဗန်းကြီး", ""],
    artists: ["ခိုင်ထူးသာ", "ဇာတိ", "နန်းဆုဦး", "မေသဉ္ဇာဦး", ""],
    summary:
      "ဦးဇင်းလေးဝဏ္ဏသီရိနှင့် ဥပါဒါန်အစွဲကြောင့် ဆုတောင်းမှားပြီး မြွေဘဝရောက်ခဲ့ရသော ပြည့်စုံခင်တို့၏ သင်ခန်းစာယူးဖွယ် ဇာတ်လမ်းလေးတစ်ပုဒ်....",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/UPaDanDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/UPaDanMobile.jpg",
    url: "",
  },
  {
    id: "2",
    title: "မြမြ",
    directors: ["ညိုမင်းလွင်", ""],
    artists: ["သင်ဇာဝင့်ကျော်", "မင်းတော်ဝင်", "ဒီးဒီး", "", ""],
    summary:
      "မသူဇာဆိုသော မိန်းကလေးကို ဝိညာဉ်ဝင်ပူးပြီး မြမြဆိုသော မိန်းကလေးကို လူ ၃ ဦး မှ အဓမ္မပြုကျင့်ပြီး သတ်ခဲ့ကြောင်း ပြောခဲ့သည်။ သုတမင်းမြတ် နှင့် သူငယ်ချင်းတို့မှ မယုံကြည်၍ မသူဇာ ထံ သွားရောက် စုံစမ်းခဲ့ရာမှ မြမြ၏ အကြောင်းစုံကို သိခဲ့ရာမှ ...",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MyaMyaDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MyaMyaMobile.jpg",
    url: "",
  },
  {
    id: "3",
    title: "The Teacher",
    directors: ["ညိုမင်းလွင်", ""],
    artists: ["မြရာ", "မြတ်", "နှင်းဝတ်ရည်", "", ""],
    summary:
      "သရဲခြောက်သည်ဟု နာမည်ကြီးနေသော နယ်မြို့ရှိကျောင်းသို့ ဆရာမမြယာပြောင်းရွှေ့ရောက်နေသည့်နေ့မှပင် သရဲရှိ/မရှိ ကျောင်းသားများစမ်းသပ်ကြပါသည်။ ကျောင်းသို့စစ်ဆေးရေးအဖွဲ့ရောက်ရှိလာပြီး မှတ်တမ်းဓာတ်ပုံရိုက်ကြရာမှ ထိုဓာတ်ပုံထဲတွင် ဆရာမတစ္ဆေကို တွေ့ခဲ့ကြရာ ...",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TheTeacherDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TheTeacherMobile.jpg",
    url: "",
  },
];

// export const SongsData = [
//   {
//     id: "1",
//     title: "အချစ်ဦးရေသိပါစေ",
//     directors: "မင်းခန့်ဘုန်း",
//     artists: "ဂေးဂေး",
//     poster:
//       "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AchitOoYayThiPrSay.JPG",
//     url: "https://www.youtube.com/watch?v=fkTocn-TLec&list=RDfkTocn-TLec&start_radio=1",
//   },
//   {
//     id: "2",
//     title: "မတွေ့ခဲ့ကြရင်",
//     directors: "အောင်မင်းထွန်း, ထွန်းအိန္ဒြာဗိုလ်",
//     artists: "ဝေကြီး, ဂျူဝဲလ်",
//     poster:
//       "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MaTwaeKhaeYin.jpg",
//     url: "https://www.youtube.com/watch?v=6WzMLKVp5ec",
//   },
// ];
export const SongsData = [
  {
    id: "1",
    title: "အချစ်ဦးရေသိပါစေ",
    directors: ["", ""],
    artists: [""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AchitOoYayThiPrSay.JPG",
    url: "https://www.youtube.com/watch?v=fkTocn-TLec&list=RDfkTocn-TLec&start_radio=1",
  },
  {
    id: "2",
    title: "မတွေ့ခဲ့ကြရင်",
    directors: ["‌"],
    artists: [""],
    summary: "တာတေနှင့် လျှို့ဝှက်ဆန်းကြယ်စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MaTwaeKhaeYin.jpg",
    url: "https://www.youtube.com/watch?v=6WzMLKVp5ec",
  },
];

export const TarTaydata = [
  {
    id: "1",
    title: "တာတေနှင့် ကဝေပျိုရဲ့အချစ်(၁)",
    directors: ["‌ရွှေဇင်မင်း‌ကျော်", ""],
    artists: ["နေဓန", "နန်းဆုဦး", "ယွန်းသဒ္ဒါအောင်", "", ""],
    summary: "တာတေနှင့် လျှို့ဝှက်ဆန်းကြယ်စွန့်စားခန်းများအကြောင်း",
    poster: "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TT_01.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "2",
    title: "တာတေနှင့် ကဝေပျိုရဲ့အချစ်(၂)",
    directors: ["‌ရွှေဇင်မင်း‌ကျော်", ""],
    artists: ["နေဓန", "နန်းဆုဦး", "ယွန်းသဒ္ဒါအောင်", "", ""],
    summary: "တာတေနှင့် လျှို့ဝှက်ဆန်းကြယ်စွန့်စားခန်းများအကြောင်း",
    poster: "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TT_02.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "3",
    title: "တာတေနှင့် ချစ်ကလဲ့စား",
    directors: ["‌ရွှေဇင်မင်း‌ကျော်", ""],
    artists: ["နေဓန", "နန်းဆုဦး", "ယွန်းသဒ္ဒါအောင်", "", ""],
    summary: "တာတေနှင့် လျှို့ဝှက်ဆန်းကြယ်စွန့်စားခန်းများအကြောင်း",
    poster: "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TT_03.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "4",
    title: "တာတေနှင့် ကြိုးနဲ့ကာတဲ့ခြံ",
    directors: ["‌ရွှေဇင်မင်း‌ကျော်", ""],
    artists: ["နေဓန", "မင်းသူ", "ကျော်သစ်", "ယွန်းသဒ္ဒါအောင်", ""],
    summary: "တာတေနှင့် လျှို့ဝှက်ဆန်းကြယ်စွန့်စားခန်းများအကြောင်း",
    poster: "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TT_04.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "5",
    title: "တာတေနှင့် ရမ္မက်သားကောင်",
    directors: ["‌ရွှေဇင်မင်း‌ကျော်", ""],
    artists: ["နေဓန", "ဒေါင်းဝေ", "ကျော်သစ်", "", ""],
    summary: "တာတေနှင့် လျှို့ဝှက်ဆန်းကြယ်စွန့်စားခန်းများအကြောင်း",
    poster: "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TT_05.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "6",
    title: "တာတေနှင့် ငရဲခွေး",
    directors: ["‌ရွှေဇင်မင်း‌ကျော်", ""],
    artists: ["နေဓန", "ယွန်းသဒ္ဒါအောင်", "", "", ""],
    summary: "တာတေနှင့် လျှို့ဝှက်ဆန်းကြယ်စွန့်စားခန်းများအကြောင်း",
    poster: "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TT_06.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "7",
    title: "တာတေနှင့် အမှောင်ထဲကရယ်သံ",
    directors: ["‌ရွှေဇင်မင်း‌ကျော်", ""],
    artists: ["နေဓန", "အကယ်ဒမီ အောင်ခိုင်", "ဦးမြမောင်", "ကိုဒေး", ""],
    summary: "တာတေနှင့် လျှို့ဝှက်ဆန်းကြယ်စွန့်စားခန်းများအကြောင်း",
    poster: "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TT_07.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "8",
    title: "တာတေနှင့် ကန်တော်ကဝေ",
    directors: ["‌ရွှေဇင်မင်း‌ကျော်", ""],
    artists: ["နေဓန", "ပိုးဝါလေး", "ထူးသာ", "", ""],
    summary: "တာတေနှင့် လျှို့ဝှက်ဆန်းကြယ်စွန့်စားခန်းများအကြောင်း",
    poster: "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TT_08.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "9",
    title: "တာတေနှင့် ကဝေရန်ငြိုး",
    directors: ["‌ရွှေဇင်မင်း‌ကျော်", ""],
    artists: ["နေဓန", "ဦးမင်းသစ်", "ဖိုးတာ", "နေထက်", ""],
    summary: "တာတေနှင့် လျှို့ဝှက်ဆန်းကြယ်စွန့်စားခန်းများအကြောင်း",
    poster: "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TT_09.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "10",
    title: "တာတေနှင့် ဂူအောင်းကဝေ",
    directors: ["‌ရွှေဇင်မင်း‌ကျော်", ""],
    artists: ["နေဓန", "ခေးကို", "ထူးသာ", "", ""],
    summary: "တာတေနှင့် လျှို့ဝှက်ဆန်းကြယ်စွန့်စားခန်းများအကြောင်း",
    poster: "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TT_10.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "11",
    title: "တာတေနှင့် ရေမြောကမ်းတင်",
    directors: ["‌ရွှေဇင်မင်း‌ကျော်", ""],
    artists: ["နေဓန", "ယွန်းသဒ္ဒါအောင်", "ဆူးလေး", "ထူးခြား", ""],
    summary: "တာတေနှင့် လျှို့ဝှက်ဆန်းကြယ်စွန့်စားခန်းများအကြောင်း",
    poster: "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TT_11.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
  {
    id: "12",
    title: "တာတေနှင့် သွားနှုတ်တဲ့တစ္ဆေ",
    directors: ["‌ရွှေဇင်မင်း‌ကျော်", ""],
    artists: ["နေဓန", "ရွှေရည်မောင်", "ကျော်သစ်", "", ""],
    summary: "တာတေနှင့် လျှို့ဝှက်ဆန်းကြယ်စွန့်စားခန်းများအကြောင်း",
    poster: "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TT_12.jpg",
    url: "https://www.youtube.com/@SEINHTAYFilmProduction",
  },
];

export const MgMoeSwaydata = [
  {
    id: "1",
    title: "ဝမ်းတွင်းကဝေမောင်မိုးဆွေ(အပိုင်း-၁)",
    directors: ["ထက်ကျော်)", ""],
    artists: ["ဟင်နရီစံ", "ဇာတိ", "မြယာ", "သံစဥ်ဖြိုးပိုင်", "အေးသန္တာဗို"],
    summary: "ဝမ်းတွင်းက ဝေမောင်မိုးဆွေ၏ စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    url: "https://www.youtube.com/watch?v=w9v0EY4_5Os&list=PLs9cgwdepJozJQw2_v9f1WncGCCsyTxV5&index=14",
  },
  {
    id: "2",
    title: "ဝမ်းတွင်းကဝေမောင်မိုးဆွေ(အပိုင်း-၂)",
    directors: ["ထက်ကျော်)", ""],
    artists: ["ဟင်နရီစံ", "ဇာတိ", "မြယာ", "သံစဥ်ဖြိုးပိုင်", "အေးသန္တာဗို"],
    summary: "ဝမ်းတွင်းက ဝေမောင်မိုးဆွေ၏ စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    url: "https://www.youtube.com/watch?v=m9tnmpx9bOo&list=PLs9cgwdepJozJQw2_v9f1WncGCCsyTxV5&index=13",
  },
  {
    id: "3",
    title: "ဝမ်းတွင်းကဝေမောင်မိုးဆွေ(အပိုင်း-၃)",
    directors: ["ထက်ကျော်)", ""],
    artists: ["ဟင်နရီစံ", "ဇာတိ", "မြယာ", "သံစဥ်ဖြိုးပိုင်", "အေးသန္တာဗို"],
    summary: "ဝမ်းတွင်းက ဝေမောင်မိုးဆွေ၏ စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    url: "https://www.youtube.com/watch?v=jWH1p1Tf-EU&list=PLs9cgwdepJozJQw2_v9f1WncGCCsyTxV5&index=12",
  },
  {
    id: "4",
    title: "ဝမ်းတွင်းကဝေမောင်မိုးဆွေ(အပိုင်း-၄)",
    directors: ["ထက်ကျော်)", ""],
    artists: ["ဟင်နရီစံ", "ဇာတိ", "မြယာ", "သံစဥ်ဖြိုးပိုင်", "အေးသန္တာဗို"],
    summary: "ဝမ်းတွင်းက ဝေမောင်မိုးဆွေ၏ စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    url: "https://www.youtube.com/watch?v=L5GsFhOCg0U&list=PLs9cgwdepJozJQw2_v9f1WncGCCsyTxV5&index=11",
  },
  {
    id: "5",
    title: "ဝမ်းတွင်းကဝေမောင်မိုးဆွေ(အပိုင်း-၅)",
    directors: ["ထက်ကျော်)", ""],
    artists: ["ဟင်နရီစံ", "ဇာတိ", "မြယာ", "သံစဥ်ဖြိုးပိုင်", "အေးသန္တာဗို"],
    summary: "ဝမ်းတွင်းက ဝေမောင်မိုးဆွေ၏ စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    url: "https://www.youtube.com/watch?v=vI13zBYK9pg&list=PLs9cgwdepJozJQw2_v9f1WncGCCsyTxV5&index=10",
  },
  {
    id: "6",
    title: "ဝမ်းတွင်းကဝေမောင်မိုးဆွေ(အပိုင်း-၆)",
    directors: ["ထက်ကျော်)", ""],
    artists: ["ဟင်နရီစံ", "ဇာတိ", "မြယာ", "သံစဥ်ဖြိုးပိုင်", "အေးသန္တာဗို"],
    summary: "ဝမ်းတွင်းက ဝေမောင်မိုးဆွေ၏ စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    url: "https://www.youtube.com/watch?v=gIZT2RjJhtU&list=PLs9cgwdepJozJQw2_v9f1WncGCCsyTxV5&index=9",
  },
  {
    id: "7",
    title: "ဝမ်းတွင်းကဝေမောင်မိုးဆွေ(အပိုင်း-၇)",
    directors: ["ထက်ကျော်)", ""],
    artists: ["ဟင်နရီစံ", "ဇာတိ", "မြယာ", "သံစဥ်ဖြိုးပိုင်", "အေးသန္တာဗို"],
    summary: "ဝမ်းတွင်းက ဝေမောင်မိုးဆွေ၏ စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    url: "https://www.youtube.com/watch?v=6W7jeiQapcA&list=PLs9cgwdepJozJQw2_v9f1WncGCCsyTxV5&index=8",
  },
  {
    id: "8",
    title: "ဝမ်းတွင်းကဝေမောင်မိုးဆွေ(အပိုင်း-၈)",
    directors: ["ထက်ကျော်)", ""],
    artists: ["ဟင်နရီစံ", "ဇာတိ", "မြယာ", "သံစဥ်ဖြိုးပိုင်", "အေးသန္တာဗို"],
    summary: "ဝမ်းတွင်းက ဝေမောင်မိုးဆွေ၏ စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    url: "https://www.youtube.com/watch?v=2s10OMUOc64&list=PLs9cgwdepJozJQw2_v9f1WncGCCsyTxV5&index=7",
  },
  {
    id: "9",
    title: "ဝမ်းတွင်းကဝေမောင်မိုးဆွေ(အပိုင်း-၉)",
    directors: ["ထက်ကျော်)", ""],
    artists: ["ဟင်နရီစံ", "ဇာတိ", "မြယာ", "သံစဥ်ဖြိုးပိုင်", "အေးသန္တာဗို"],
    summary: "ဝမ်းတွင်းက ဝေမောင်မိုးဆွေ၏ စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    url: "https://www.youtube.com/watch?v=sMUSTmfNuCE&list=PLs9cgwdepJozJQw2_v9f1WncGCCsyTxV5&index=6",
  },
  {
    id: "10",
    title: "ဝမ်းတွင်းကဝေမောင်မိုးဆွေ(အပိုင်း-၁၀)",
    directors: ["ထက်ကျော်)", ""],
    artists: ["ဟင်နရီစံ", "ဇာတိ", "မြယာ", "သံစဥ်ဖြိုးပိုင်", "အေးသန္တာဗို"],
    summary: "ဝမ်းတွင်းက ဝေမောင်မိုးဆွေ၏ စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    url: "https://www.youtube.com/watch?v=CmhUY5oXC8Y&list=PLs9cgwdepJozJQw2_v9f1WncGCCsyTxV5&index=5",
  },
  {
    id: "11",
    title: "ဝမ်းတွင်းကဝေမောင်မိုးဆွေ(အပိုင်း-၁၁)",
    directors: ["ထက်ကျော်)", ""],
    artists: ["ဟင်နရီစံ", "ဇာတိ", "မြယာ", "သံစဥ်ဖြိုးပိုင်", "အေးသန္တာဗို"],
    summary: "ဝမ်းတွင်းက ဝေမောင်မိုးဆွေ၏ စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    url: "https://www.youtube.com/watch?v=WetwF4UUOuk&list=PLs9cgwdepJozJQw2_v9f1WncGCCsyTxV5&index=4",
  },
  {
    id: "12",
    title: "ဝမ်းတွင်းကဝေမောင်မိုးဆွေ(အပိုင်း-၁၂)",
    directors: ["ထက်ကျော်)", ""],
    artists: ["ဟင်နရီစံ", "ဇာတိ", "မြယာ", "သံစဥ်ဖြိုးပိုင်", "အေးသန္တာဗို"],
    summary: "ဝမ်းတွင်းက ဝေမောင်မိုးဆွေ၏ စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    url: "https://www.youtube.com/watch?v=g3QuP5AThOg&list=PLs9cgwdepJozJQw2_v9f1WncGCCsyTxV5&index=3",
  },
  {
    id: "13",
    title: "ဝမ်းတွင်းကဝေမောင်မိုးဆွေ(အပိုင်း-၁၃)",
    directors: ["ထက်ကျော်)", ""],
    artists: ["ဟင်နရီစံ", "ဇာတိ", "မြယာ", "သံစဥ်ဖြိုးပိုင်", "အေးသန္တာဗို"],
    summary: "ဝမ်းတွင်းက ဝေမောင်မိုးဆွေ၏ စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    url: "https://www.youtube.com/watch?v=M8hAAsEoRm0&list=PLs9cgwdepJozJQw2_v9f1WncGCCsyTxV5&index=2",
  },
  {
    id: "14",
    title: "ဝမ်းတွင်းကဝေမောင်မိုးဆွေ(အပိုင်း-၁၄)",
    directors: ["ထက်ကျော်)", ""],
    artists: ["ဟင်နရီစံ", "ဇာတိ", "မြယာ", "သံစဥ်ဖြိုးပိုင်", "အေးသန္တာဗို"],
    summary: "ဝမ်းတွင်းက ဝေမောင်မိုးဆွေ၏ စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    url: "https://www.youtube.com/watch?v=YfLdPh7yuOc&list=PLs9cgwdepJozJQw2_v9f1WncGCCsyTxV5&index=1",
  },
];

export const ComingSoonData = [
  {
    id: "1",
    title: "The Brightest Smile At The Sunset",
    directors: ["မင်းဆက်သစ်", ""],
    artists: ["ချိုပြုံး", "မြင့်မြင့်ခိုင်", ""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TheBrightestSmileAtTheSunset.JPG",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TheBrightestSmileAtTheSunset.JPG",
    video: "",
    url: "",
  },
  {
    id: "2",
    title: "မင်းတို့တွက် ရက်ရာဇာ",
    directors: ["ညိုမင်းလွင်", ""],
    artists: [""],
    summary:
      "In associated with ညကျောင်းရုပ်ရှင်ထုတ်လုပ်ရေး Coming On May/2026",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MinTohTwatYatYarZar.JPG",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MinTohTwatYatYarZar.JPG",
    video: "",
    url: "",
  },
  {
    id: "3",
    title: "မေမေ့အချစ်ဦး",
    directors: ["မင်းဆက်သစ်", ""],
    artists: ["ဟင်နရီစံ", "မေမီကိုကို", "သဲစုညိမ်း"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MayMay'sAchitOo.JPG",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MayMay'sAchitOo.JPG",
    video:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MayMay'sAchitOo.MP4",
    url: "",
  },
  {
    id: "4",
    title: "၀မ်းတွင်းက၀ေ မောင််မိုးဆွေ",
    directors: ["", ""],
    artists: [""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/WannTwinKaWay.JPG",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/WannTwinKaWay.JPG",
    video: "",
    url: "",
  },
  {
    id: "5",
    title: "သဘင်သည်မြနှင်းဆီ",
    directors: ["", ""],
    artists: [""],
    summary:
      'ပရိသတ်​ ရင်ထဲရောက်ခဲ့ပြီးသားဖြစ်တဲ့​ 🥀​💞"သဘင်သည်မြနှင်းဆီ (The Beginning)" ရုပ်ရှင်ဇာတ်ကားကြီးကို🎬 ပရိသတ်တွေရုပ်ရှင်ဇာတ်ကားတွင်လုံးဝမကြည့်ရသေးတဲ့ အပိုင်းတွေအများကြီးပါဝင်တဲ့ဇာတ်လမ်းတွဲအဖြစ်​ ပရိသတ်တွေထံပြန်လည်ရောက်ရှိလာတော့မှာဖြစ်ပါတယ်😍​🥀 "သဘင်သည်မြနှင်းဆီ (The Beginning)" Episodes များကို 🗓️ အပတ်စဉ် - Mon to Fri⏰ အချိန်-ည​ (8)​နာရီ​ တိုင်းမှာSein Htay YouTube Channel, Hey​ play​ Application, Hey Play YouTube Channel, Fortune TV, ShweStream Application တို့မှာ​တပြိုင်နက်ထုတ်လွှတ်ပြသနေပါသည်။ မနက်ဖြန်ည(8)နာရီမှာစတင်ကြည့်ရှုလို့ရနေပြီ🌹',
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TheBeginningWeb.JPG",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TheBeginningMobile.JPG",
    video:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/Mya+Hnin+Si+Trailer+Final+Color+1080_1.mp4",
    url: "",
  },
  {
    id: "6",
    title: "အောင်မြတ်သာနှင့်ဖြစ်ရပ်ဆန်းများ",
    directors: ["", ""],
    artists: [""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AungMyatTharNintPhyitYatSanMyar.jpeg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AungMyatTharNintPhyitYatSanMyar.jpeg",
    video: "",
    url: "",
  },
  {
    id: "7",
    title: "ဖုန်းရွှေ",
    directors: ["အကယ်ဒမီ ညိုမင်းလွင်", ""],
    artists: [""],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/PhoneShweWeb.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/PhoneShweMobile.jpg",
    video:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/PhoneShweTrailer.mp4",
    url: "",
  },
  {
    id: "8",
    title: "အဆပ်မဲ့ဆူး",
    directors: ["နေထက်ဇာန်", ""],
    artists: [
      "ဇာတိ",
      "ဂျွန်နိုင်းအောင်",
      "ဖြိုးမွန်",
      "မင်းသူ",
      "ဇော်ဝင်းနိုင်",
      "သားလျှံဧ",
      "နေအောင်လွင်",
      "ဦးဇော်မှိုင်း",
      "စိုးမိုးကြည်",
      "အကယ်ဒမီ ခင်မို့မို့အေး",
      "သန်းသန်းစိုး",
      "ယွန်းသဒ္ဒါဟန်",
      "အိရွှန်းမဒီ",
      "အေးစန္ဒာချစ်",
      "ဇူဇူပန်ဇင်",
      "ဇိုင်းထက်",
    ],
    summary: [
      "(၁) အတ္တကို ရှေ့တန်းမတင်သင့်ကြောင်းအသိပညာပေးရန်။",
      "(၂) မရည်ရွယ်ဘဲပြုလုပ်မိသော အမှားများသည် အဆိပ်အတောက်ဖြစ်စေနိုင်ကြောင်းအသိပညာပေးရန်။",
      "(၃) ဒေါသဖြင့်ပြုလုပ်မိသောအမှားများသည် တစ်ချိန်တွင်ပြန်လည်ပြင်ဆင်၍ မရကြောင်းအသိပညာပေးရန်။",
    ],
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AsateMaeSuuWeb.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AsateMaeSuuWeb.jpg",
    video: "",
    url: "",
  },
  {
    id: "9",
    title: "ဥတုမှားတဲ့ဆောင်း",
    directors: ["ကျော်နှင်းဆီ", ""],
    artists: ["ညိမ်းသော်", "နန်းဆုဦး", "ခင်ဇာခြည်ကျော်", "ဆုထက်", "မိုခမ်း"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/OuTuMhrrTkSaungDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/OuTuMhrrTkSaungMobile.jpg",
    video: "",
    url: "",
  },
  {
    id: "10",
    title: "သဘင်သည်မြနှင်းဆီ ၂",
    directors: ["ကိုဆက်", ""],
    artists: ["", "", "", "", ""],
    summary:
      '"မေမေက သိပ်လှတယ်... သိပ်ကျက်သရေရှိတယ် နောက်ပြီး... သိပ်လည်း ရက်စက်တယ် နှင်းဆီ မေမေ့ကိုသိပ်မုန်းတယ် မေမေ" ---------------------- ၂၀၂၂ ခုနှစ်ရဲ့  Hit  အဖြစ်ခဲ့ဆုံးသော မြန်မာအငြိမ့်မင်းသမီးသရဲ ရုပ်သံဇာတ်လမ်းတွဲကြီး " သဘင်သည်မြနှင်းဆီ " ရဲ့  𝐒𝐞𝐚𝐬𝐨𝐧 [ 𝟐 ] .... အရာအားလုံးရဲ့အစ နှင်းဆီနီတစ်ပွင့်ရဲ့ နိဒါန်း သို့မဟုတ် .... " သဘင်သည်မြနှင်းဆီ | THE BEGINNING "  🌹 ',
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MyaHninSi2Mobile.jpg",
    video: "",
    url: "",
  },
];

export const SeriesData = [
  {
    id: "1",
    title: "အောင်မြတ်သာလူသားစားရေတွင်း",
    directors: ["အကယ်ဒမီ ညိုမင်းလွင်"],
    artists: [
      "ထွန်းကိုကို အောင်ဆန်းမြင့် အောင်ဖြိုးလင်း နေလင်း လင်းထည်ဝါ ဘုန်းမင်းခန့်  အေးမြတ်သန္တာ မေမြတ်သူ ဦမျိုးအောင် ကိုဒေါင်း ညီလင်းညို ကျားကြီး ရွာသူရွာသားများ",
    ],
    summary:
      "ပေါက်ကျောနှင့်စိန်လှတို့က တစ်နေ့ အောင်မြတ်သာတို့ တည်းနေတဲ့ ဇရပ်ဆီရောက်လာပြီး ရွာသူကြီက သူတို့ ရောက်လာမည်ဟု ပြောထား၍ ရောက်လာခြင်းဖြစ်ကြောင်းနဲ့ သူတို့ရွာမှ တစ်လကို လူတစ်ယောက်ပျောက်နေတဲ့ ကိစ္စက ရွာက နတ်ရေတွင်းကြီးနဲ့ဆိုင်တဲ့အကြောင်းတွေ ပြေပြခဲ့တယ် သူတို့နတ်ရေတွင်းကို ဘာဆက်လုပ်ကြမလဲဆိုတာ",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_LTSYT+Web.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AMT_LTSYT+Mobile.jpg",
    video:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AungMyatTharLuuTharSarYayTwin.mp4",
    url: "",
  },
  {
    id: "2",
    title: "သဘင်သည်မြနှင်းဆီ",
    directors: ["ကိုဆက်", ""],
    artists: ["မင်းဆက်သစ်", "စည်သူအုတ်စိုး", "ကောင်းထက်ပိုင်", "စင်ဒီမြတ်", ""],
    summary:
      "မြနှင်းဆီစံအိမ် သည် သဘင်သည်မြနှင်းဆီ​၏ စံအိမ်တော်ဖြစ်ပြီး သူမ​၏ဝိညာဉ် ကိန်းအောင်းနေသည်ဟု နာမည်ကြီးသော စံအိမ်ဖြစ်သည် ။ မြနှင်းဆီ ဆိုသည်မှာ လွန်ခဲ့သော နှစ်ပေါင်းများစွာက ထိပ်တန်းစာရင်းဝင်ဒိတ်ဒိတ်ကြဲ အငြိမ့်မင်းသမီးတစ်ဦးဖြစ်ပြီး သူမ​၏စံအိမ်တော်မှာပဲ ကိုယ့်ကိုယ်ကို အဆုံးစီရင်ကာ ဘဝနိဂုံးချုပ်သွားခဲ့သူဖြစ်သည် ။ မြနှင်းဆီ တစ်ယောက် မည်သည့်အကြောင်းကြောင့်  ထိုကဲ့သို့ အဆုံးစီရင်သွားသည်ဆိုတာကတော့ ယနေ့အချိန်အထိ မည်သူမှ သေသေချာချာသိရှိခြင်းမရှိပါ ။ သို့ပေမယ့် ...  မြနှင်းဆီခြံသည် ကြောက်မက်ဖွယ်ကောင်းအောင် ခြောက်လန့်လျက်ရှိသည် ဆိုသော သတင်းကတော့ တစ်နိုင်ငံလုံးကို ပျံ့နှံ့လျက်ရှိပေသည် ။ ​သဘင်သည်မြနှင်းဆီ  ဘာကြောင့် ကိုယ့်ကိုယ်ကို အဆုံးစီရင်ခဲ့သလဲ... သူမ မသေခင်မှာ ဘာအကြောင်းကိစ္စတွေရှိခဲ့တာလဲ... နှစ်ပေါင်းများစွာ မကျွတ်မလွတ်ဘဲရှိနေရလောက်သည်အထိ အမုန်းတရားတွေကြီးမားခဲ့ရတဲ့အကြောင်းတွေက ဘာတွေလဲ...  အရာအားလုံးကိုသိနေတဲ့ ဒေါ်နီနီ ကရော ဘာလို့ ရေငုံနှုတ်ဆိတ်နေရတာလဲ...",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MyaHninSiDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/MyaHninSiMobile.jpg",
    url: "",
  },
  {
    id: "3",
    title: "ချစ်ကြွေးဝိဥာည်",
    directors: ["ကျော်နှင်းဆီ", ""],
    artists: [
      "ချမ်းမင်းရဲထွဋ်",
      "နန်းဆုဦး",
      "သင်ဇာမြင့်မိုရ်",
      "စိုးမိုးကြည်",
      "ဦးညီညီမင်း",
    ],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/ChitKywyWutNyiDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/ChitKywyWutNyiMobile.jpg",
    url: "",
  },
  {
    id: "4",
    title: "လူပျောက်ကြော်ငြာ",
    directors: ["STAR", ""],
    artists: [
      "စစ်နိုင်",
      "ရွှေပိုးအိမ်",
      "ခိုင်သဇင်",
      "အိမ့်နဒီ",
      "နော်အဲလ်လီ",
    ],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/LuuPyoutKyawNyarDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/LuuPyoutKyawNyarMobile.jpg",
    url: "",
  },
  {
    id: "5",
    title: "7 Days",
    directors: ["STAR", ""],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ရဲရင့်", "မင်းဇော်", "ခိုင်သဇင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/7DayDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/7DayMobile.jpg",
    url: "",
  },
  {
    id: "6",
    title: "အောင်မြတ်သာ",
    directors: ["သီဟမင်းညီ"],
    artists: ["စစ်နိုင်", "လင်းအောင်", "ဟန်ဆက်လူ", "နန်းခန်းဝါ"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AgMyatTharDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/AgMyatTharMobile.jpg",
    url: "https://www.youtube.com/watch?v=uKnkXsJra-0",
  },
  {
    id: "7",
    title: "နံရံ၏နောက်ကွယ်",
    directors: ["ဟိန်းဇော်"],
    artists: ["ထိုက်တန်", "စစ်နိုင်", "ဘုန်းသျှံ", "ရဲမျိုးမြတ်လင်းအောင်"],
    summary: "",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/BehindTheWallDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/BehindTheWallMobile.jpg",
    url: "https://www.youtube.com/watch?v=w3Ht71_ssNA",
  },
  {
    id: "8",
    title: "တာတေနှင့် လျှို့ဝှက်ဆန်းကြယ်စွန့်စားခန်းများ",
    directors: ["‌ရွှေဇင်မင်းကျော်"],
    artists: ["နေဓန", "နန်းဆုဦး", "ယွန်းသဒ္ဒါအောင်", ""],
    summary: "တာတေနှင့် လျှို့ဝှက်ဆန်းကြယ်စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TarTayDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/TarTayMobile.jpg",
    url: "",
  },
  {
    id: "9",
    title: "ဝမ်းတွင်းကဝေမောင်မိုးဆွေ",
    directors: ["ထက်ကျော်)", ""],
    artists: ["ဟင်နရီစံ", "ဇာတိ", "မြယာ", "သံစဥ်ဖြိုးပိုင်", "အေးသန္တာဗို"],
    summary: "ဝမ်းတွင်းက ဝေမောင်မိုးဆွေ၏ စွန့်စားခန်းများအကြောင်း",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/mgmoesway.jpg",
    url: "",
  },
];

export const MovieSynopsisData = [
  {
    id: "4",
    title: "၃/က",
    directors: ["အောင်ချမ်းလူ", ""],
    artists: ["ချမ်းမင်းရဲထွဋ်", "စိုးမြတ်သူဇာ", "နန်းဆုဦး", "", ""],
    summary:
      "ကံကြမ္မာအလှည့်အပြောင်းအဆိုးအဝါးများကြောင့် ပြည့်တန်ဆာဘဝသို့‌ရောက်ခဲ့ရသော်လည်း ဘဝကိုအလျော့မပေး အဆုံးထိရုန်းကန်မည့် ခေါင်ဆိုင် နှင့် သူမကဲ့သို့ အနိုင်ကျင့်အမြတ်ထုတ်ခံနေရသော အမျိုးသမီးများကို ကူညီပေးသည့် ကိုမျိုးနိုင်တို့ တွေ့ဆုံခဲ့ရာမှ ...",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/3aDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/3aMobile.jpg",
    url: "",
  },
  {
    id: "5",
    title: "အီဖေကိုတို့ ရွေးကောက်ပွဲ",
    directors: ["ညီညီထွန်းလွင်", ""],
    artists: [
      "ခန့်စည်သူ",
      "ဇေရဲထက်",
      "ထွန်းထွန်း",
      "ညီထွဍ်ခေါင်",
      "နန်းမြတ်ဖြိုးသင်း",
    ],
    summary:
      "သူကြီးသမီးရဲ့အချစ်ကိုရဖို့ ရွေးကောက်ပွဲလုပ်ကာ ယှဥ်ပြိုင်ကြတဲ့ လူငယ်နှစ်ယောက် ၊ သူတို့ရဲ့ရွေးကောက်ပွဲထဲ မဖိတ်ခေါ်ဘဲ ရွာကိုရောက်လာတဲ့ သူစိမ်းတစ်ယောက် ပါဝင်လာသောအခါ ၊ ရွေးကောက်ပွဲမှာ သူမတူတဲ့မဲဆွယ်မှုတွေနဲ့ တစ်ကားလုံး ဘယ်လိုဟားသွားရလဲဆိုတာ...",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/EPhayKoDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/EPhayKoMobile.jpg",
    url: "https://www.youtube.com/watch?v=5KCCWFbJTJU",
  },
  {
    id: "6",
    title: "ကြိုးဖြင့်ချည်ထားသော ဗာရာဏသီ",
    directors: ["သားကြီး", ""],
    artists: ["ဗေလုဝ", "နေမျိုးအောင်", "နေဒွေး", "ခိုင်သင်းကြည်", "ဒိန်းဒေါင်"],
    summary:
      "အယူအဆအမှားတွေကို အယုံကြည်လွန်နေတဲ့ ရွာလေးတစ်ရွာက လူတွေနဲ့ ထိုလူတွေရဲ့ အယုံကြည်လွန်မှုကို အသုံးချပြီး စီးပွားရှာနေတဲ့ လူတွေအကြောင်းကို ဟာသနှောပြီး ရိုက်ကူးထားတဲ့ ရုပ်ရှင်ကားကောင်းတစ်ကား ၊ ဒီကားလေးကို ကြည့်ရှုခြင်းဖြင့် သံဝေဂရစရာတွေ ရယ်မောစရာရသတွေကို တစ်ပြိုင်တည်းခံစားရမှာမို့ အကျိုးမယုတ်ပါဘူးလို့ ပြောပါရစေနော်...",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/KyoeBarYarNaThiDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/KyoeBarYarNaThiMobile.jpg",
    url: "https://www.youtube.com/watch?v=52UhOS81TYM",
  },
  {
    id: "7",
    title: "လက်ပံ",
    directors: ["ဝိုင်း (Own Creator)", ""],
    artists: ["ပြေတီဦး", "စိုးမြတ်သူဇာ", "ဖွေးဖွေး", "", ""],
    summary:
      "လက်ပံပင်မှစခဲ့‌သော ချစ်ဇာတ်လမ်းတစ်ပုဒ်က ‌သွေးရဲရဲနီ‌‌သောအမုန်းတရားသို့ ပြောင်းလဲလာသောအခါ ၊ ငယ်ငယ်ထဲက အကြောက်တရားမရှိ ရဲရင့်အောင်ပျိုးထောင်ပြီး ကြီးပြင်းလာသော လက်ပံဆိုတဲ့ ကောင်မလေး ၊ ငယ်စဥ်ကတည်းက မမြင်ဖူးတဲ့အဖေကို မုန်းတီးနေတဲ့သမီးကြောင့် သမီးလို့ခေါ်ခွင့်မရှိတဲ့ ဖခင်တစ်ယောက်ရဲ့ ရင်နင့်ဖွယ်ဖြစ်ရပ် ၊ လက်ပံရဲ့ အမုန်းတရားတွေကို အဖေဖြစ်သူ ဘယ်လိုပြေလျော့စေမလဲဆိုတာ...",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/LatPanDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/LatPanMobile.jpg",
    url: "https://www.youtube.com/watch?v=cMXE3D4b9oc",
  },
  {
    id: "8",
    title: "လော်မင်္ဂလာ - အပိုင်း ၁",
    directors: ["ထွန်းအောင်ဇော်", ""],
    artists: [
      "ရန်အောင်",
      "လူမင်း",
      "ဖိုးချစ်",
      "နောင်နောင်",
      "မေသန်းနု",
      "မေသဉ္ဇာဦး",
      "မေသက်ခိုင်",
      "အိချောပို",
    ],
    summary:
      "နာမည်ကြီးကာတွန်းဇာတ်ကောင်တွေကို အသက်ပြန်သွင်းထားတဲ့ ဟာသရုပ်ရှင်ဇာတ်ကားကြီး ၊ လော်စပီကာလိုချင်နေသော ယောက်ဖဖြစ်သူ ဗိုက်ကလေးအား တွတ်ပီတစ်ယောက် နားမခံနိုင်တဲ့အဆုံး ဝယ်ပေးလိုက်ရသောအခါ ၊ ဗိုက်ကလေးတစ်ယောက် ထိုလော်စပီကာကြီးနဲ့ တစ်ရွာလုံးကို ဘယ်လိုပတ်မွှေပြီး ဘယ်လိုရယ်မောသွားရမလဲဆိုတာ...",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/LawMingalarDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/LawMingalarMobile.jpg",
    url: "https://www.youtube.com/watch?v=Kob1ngDrw-8",
  },
  {
    id: "8",
    title: "နတ်ဖက်တဲ့စုံတွဲများ",
    directors: ["ကိုဇော်(အရုဏ်ဦး)", ""],
    artists: [
      "ရဲအောင်",
      "ပြေတီဦး",
      "နန္ဒ ",
      "စိုးမြတ်သူဇာ",
      "အိန္ဒြာကျော်ဇင်",
      "သက်မွန်မြင့်",
    ],
    summary:
      "အကျင့်စရိုက်ပြောင်းပြန်ဖြစ်နေတဲ့ ချစ်သူစုံတွဲနှစ်တွဲ ၊ တစ်နေ့သူတို့စုံတွဲနှစ်တွဲ လူချင်းလဲကာ လက်တွဲဖို့ဖြစ်လာရသောအခါ ၊ သူတို့စုံတွဲနှစ်တွဲ နတ်ဖက်တဲ့စုံတွဲတွေ ဖြစ်လာမလားဆိုတာ အရယ်အမောတွေနဲ့ အပန်းပြေသွားစေမဲ့ ရုပ်ရှင်ကားလေးပါလို့ ညွှန်းပါရစေနော်...",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/NatPhatTaeSoneTwlMyarDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/NatPhatTaeSoneTwlMyarMobile.jpg",
    url: "https://www.youtube.com/watch?v=wundDbaQzv4",
  },
  {
    id: "10",
    title: "နိုနိုမေဂျူဂျူ",
    directors: ["နောင်ထွန်းလွင်", "ညီညီထွန်းလွင်"],
    artists: ["လွင်မိုး", "စိုးမြတ်သူဇာ", "မေသဥ္ဇာဦး", "ထက်ထက်မိုးဦး", "", ""],
    summary:
      "တက္ကသိုလ်က ဆရာမအပျိုကြီး နိုနို ၊ တက္ကသိုလ်မှာ ယောက်ျားလေးတွေရဲ့အသည်းစွဲဖြစ်သလို ခေတ်နဲ့အမှီနေထိုင်တတ်တဲ့ မေ ၊ အချစ်က ကားမောင်းတာလောက် ရင်ခုန်ဖို့မကောင်းဘူးဆိုတဲ့ ခေတ်ရှေ့ပြေးတဲ့ ဂျူဂျူ ၊ မေကို စိတ်ဝင်စားနေတဲ့ ဧရာ ဆိုတဲ့ကောင်လေး အကြောင်းအမျိုးမျိုးကြောင့် နိုနို နဲ့ ဂျူဂျူတို့နဲ့ပါ ပတ်သက်ခဲ့ရပြီး ထိုပတ်သက်လာရခြင်းသည် တစ်စုံတစ်ယောက်ရဲ့ အကွက်ချစီစဥ်မှုဆိုတာ သိလိုက်ရသောအခါ ၊ ဧရာတစ်ယောက် မေရဲ့အချစ်ကိုရဖို့ ဘယ်လိုတံတိုင်းတွေကို ကျော်ဖြတ်သွားရမလဲဆိုတာ...cd",
    poster:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/NoNoMayJuJuDesktop.jpg",
    poster_mobile:
      "https://sh-web-assests.s3.ap-southeast-1.amazonaws.com/S_007.jpg",
    url: "https://www.youtube.com/watch?v=5LOe04dmEcg",
  },
];
